import SetData from "@/vuex/SetData";
import Config from "@/vuex/Config";
import CatchFetch from "@/assets/Cache/Fetch";
import Logger from "@/assets/Helper/Logger";

let DAOItemAdditionalItems = function () {

    this.getItems = function (itemnumbers) {
        if (Array.isArray(itemnumbers)) {
            CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/items/additional/' + itemnumbers.join('/') + '/')
                .then(json => {
                    SetData.dispatch('setAdditionalItems', json).catch((error) => {
                        Logger.error(error);
                    });
                })
                .catch((error) => {
                    Logger.error(error);
                });
        }
    }
}

export default new DAOItemAdditionalItems();